<template>
	<div>
		<div class="scrollbar first-wishlist favItem mt-0">
			<ul class="d-flex align-items-center comp-toggle border-0">
				<li :class="(tab == '')?'active':''"><a href="#" class="active" @click.prevent="tab = ''">{{$t('all')}}</a></li> 
				<li :class="(tab == 'FOREX')?'active':''"><a href="#" class="active" @click.prevent="tab = 'FOREX'">{{$t('forex')}}</a></li> 
				<li :class="(tab == 'INDICES')?'active':''"><a href="#" class="active" @click.prevent="tab = 'INDICES'"> {{$t('indices')}}</a></li> 
				<li :class="(tab == 'COMMODITIES')?'active':''"><a href="#" class="active" @click.prevent="tab = 'COMMODITIES'">{{$t('commodities')}}</a></li> 
				<li :class="(tab == 'CRYPTO')?'active':''"><a href="#" class="active" @click.prevent="tab = 'CRYPTO'">{{$t('cryptos')}}</a></li> 
				<!-- <li :class="(tab == '')?'active':''"><a href="#" class="active">Crypto</a></li> -->
			</ul>
		</div>
		<div class="leftData news scrollbar">
			<app-loader v-if="pageLoader"/>
			<div v-if="newsData.records && newsData.records.length > 0">
			 	<div class="elementHistoy border-bottom" v-for="list in newsData.records">
			 		<span class="buttonType">{{list.category}}</span>
			 		<h5>{{list.title}}</h5>
			 		<p v-html="list.description.slice(0,150)" v-if="list.description"></p>
			 		<div class="d-flex justify-content-between align-items-center">
			 			<p class="uppercase m-0">{{list.tags.split(",").slice(0,1).join(',')}}</p>
			 			<span class="date d-flex align-items-center"><feather class="mr-1" size="12px" type="calendar"></feather>{{fromDate(list.created)}}</span>
			 		</div>
			 	</div>
			</div>
		 	<no-data class="noData border-0 py-4" v-else-if="!pageLoader && newsData.records && newsData.records.length == 0" text="Opps! <span>No Data</span>"/>
		</div>
    </div>
</template>
<script>
	import buy_sell_tabing from './buy-sell-tabing'
	import news_popup from '../../shared/news-popup'
	import { commonAllmixins } from '@/plugins/commonAll'
	import moment from 'moment'
	export default {
	    name: 'news-Section',
	    mixins: [commonAllmixins],
	    data() {
	        return {
	        	pageLoader : false,
	        	newsPopup : false,
	        	tab:''
	        }
	    },
	    watch:{
	    	tab(val){
	    		this.listing()
	    	}
	    },
	    components:{
    		appNewspopup : news_popup,
    	},
	    methods:{
	    	fromDate(date){
	    		let d = new Date(date)
	    		return moment(d).fromNow()
	    	},
	    	listing(){
	    		// "category": "Stock Market"
	    		let inputJson = {
	    			'globalParams' : {
	    				"category_type": this.tab,
	    				"page":1,
	    				"perPage":20
	    			},
	    			'localParams' : {'parameter' : this}
	    		}

	    		if(this.tab == '') delete inputJson['globalParams']['category_type']
	    		this._runGetNewsData(inputJson)
	    	}
	    },
	    created(){
	    	if(!(this.newsData.records && this.newsData.records.length > 0)){
	    		this.listing()
	    	}
	    },
	    mounted() {
			/*const _that = this
	        $(document).on("click", function(event){
	            if(!$(event.target).closest('.openPendingOrder').length){
	                _that.pendingOrder = false
	            }
	            
	        });*/
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/user/home-elements/news-section.vue